import React from 'react';
import ManageTemplateDialog from '../../../../ui/ManageTemplateDialog';
import { ChannelGroup } from '../../../../../shared/types';

interface ChannelGroupDeleteDialogProps {
    dialogOpen: boolean;
    selectedGroup: ChannelGroup | null;
    deleting: boolean;
    onClose: () => void;
    onConfirmDelete: () => void;
}

const DeleteDialog: React.FC<ChannelGroupDeleteDialogProps> = ({
    dialogOpen,
    selectedGroup,
    deleting,
    onClose,
    onConfirmDelete,
}) => (
    <ManageTemplateDialog
        dialogOpenState={dialogOpen}
        closeDialog={onClose}
        title="Remove channel group"
        dialogMessage={
            selectedGroup?.name
                ? `Are you sure you want to remove "${selectedGroup.name}"?`
                : ''
        }
        onDelete={onConfirmDelete}
        submitBtnText="Remove"
        submitBtnColorType="error"
        submitBtnDisabled={deleting}
    />
);

export default DeleteDialog;
